import Icons from '@/components/icons'
import Icon from '@/components/icon'


export default [
  Icons,
  Icon
]